export default "__VITE_ASSET__bCp9Ye69__"